module.exports = __webpack_public_path__ + "media/images/communities/samsung_dark-236fe089a409353d169d9babf9e05df4.png";